import { Injectable } from "@angular/core";
import { HttpClient, HttpEventType, HttpHeaders } from "@angular/common/http";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { DatePipe } from '@angular/common';
import {
  BehaviorSubject,
  Observable,
  ReplaySubject,
  Subject,
  Subscription,
  throwError,
  TimeoutError,
  of,
} from "rxjs";
import { catchError, map, timeout, retry } from "rxjs/operators";
import { RouteAuthService } from "../menu/route-auth.service";
import { AuthService } from "../auth/auth.service";
import { AppStore } from "../../store/app.store";
import API from "../../shared/apis.json";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
declare var Stripe: any;
// import { Intercom } from "ng-intercom";
import { Location } from "@angular/common";
import { LoaderService } from "src/app/services/interceptor/loader.service";
import { SimpleDialogComponent } from "src/app/shared/simple-dialog/simple-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SocketsService } from "../shared/socket.service";
import * as CryptoJS from 'crypto-js';
import { ScriptLoaderService } from "../scriptLoader/script-loader.service";
import { getDoctorSettings, setDoctorSettings } from 'src/app/core/session';
declare var Intercom: any;

@Injectable({
  providedIn: "root",
})
export class MainService {
  currentUrl: string;
  previousUrl: string;
  public writeToDenefit = new Subject<boolean>();
  public addBusinessLocation = new Subject<boolean>();
  public email_value: any;
  public getLocationFilter = new Subject<boolean>();
  public getAllLocations = new Subject<any>();
  public financeData: any = JSON.parse(localStorage.getItem("getFinanceValues") || '{"data":{}}');
  public financeData$ = new ReplaySubject<any>(1);
  public getRoutes: boolean = true;
  public newfinanceUi: boolean = this.isNewFinanceThemeEnabled(this.financeData);
  private activeFinanceDoctorId: number | string | null = null;
  public personaButton$: BehaviorSubject<Boolean> = new BehaviorSubject(true);
  public subscription: any;
  public subscription_data: any;
  public storageVal = {
    delete_localstorage: "true",
    client_version: "6",
    hard_reload: "false",
  };
  // tslint:disable-next-line:variable-name
  public card_success_subject: Subject<any> = new Subject();
  public signatureBlob: Subject<any> = new Subject();
  public stripeData: Subject<any> = new Subject();
  public warningText: string = '';
  defaultcontact: any = {};
  private stripeKeySubject = new BehaviorSubject<string | null>(null);
  public stripe_publish_key$ = this.stripeKeySubject.asObservable();
  private expandedState = new BehaviorSubject<boolean>(true);
  expandedState$ = this.expandedState.asObservable();
  private sidebarToggleRequest = new Subject<boolean>();
  sidebarToggleRequest$ = this.sidebarToggleRequest.asObservable();
  private sidebarVisibilityRequest = new BehaviorSubject<boolean>(true);
  sidebarVisibilityRequest$ = this.sidebarVisibilityRequest.asObservable();
  constructor(
    public routerAuth: RouteAuthService,
    private _snackBar: MatSnackBar,
    public http: HttpClient,
    public router: Router,
    public location: Location,
    // public intercom: Intercom,
    public auth: AuthService,
    public loaderService: LoaderService,
    public datePipe:DatePipe,
    public dialog: MatDialog,
    public _socket: SocketsService,
    public scriptLoader: ScriptLoaderService
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
    if (this.auth.plan_info$) {
      this.auth.plan_info$.subscribe((data) => {
        if (data && Object.keys(data).length) {
          this.subscription = data;
          this.auth.plan_info$.next({});
        }
      });
    }
  }
  show_full_view: any;
  public messageList: any;
  public user_review_list: any;
  public salutation: any;
  public available_menu: BehaviorSubject<any> = new BehaviorSubject(0);
  public readonly store = inject(AppStore);
  /** Read-only views of the central store, kept for existing subscribers. */
  public readonly salutations = this.store.select("salutations");
  public readonly timezones$ = this.store.select("timezones");
  public profileImage = new Subject<any>();
  public readonly arProposals = this.store.select("arProposals");
  public readonly preapproval_leads_object = this.store.select("preapprovalLeads");
  public notification_list = [];
  public unread_count = 0;
  public stripe;
  public stripe_element;
  public persona_template_id;
  hit_subscription: boolean = true;
  public isDocUploaded: BehaviorSubject<any> = new BehaviorSubject({});
  private secretKey = 'dj434324u98fjdsf*7yeur^4u39';

  style = {
    base: {
      iconColor: "#F99A52",
      color: "#32315E",
      lineHeight: "40px",
      fontWeight: 400,
      fontSize: "14px",
      "::placeholder": {
        color: "#909090",
      },
    },
  };

  headers: any = new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "*/*",
  });
  // headers: any = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': '*/*' });
  headersObject: any = new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "*/*",
  });
  timeoutError: boolean;
  getsettings_count: number = 0;
  getsettings_response: any;
  maintenanceContent: any;
  public claimsContracInfo$: BehaviorSubject<any> = new BehaviorSubject([]);
  flagPopUps(flag: any, error: any) {
    if (flag === 377) {
      this.loginRedirect();
    }
    if (flag === 4 || flag === 309) {
      this.loginRedirect();
      return false;
    }
    if (!this.messageList || this.messageList.length === 0) {
      this.init();
    } else {
      for (let i = 0; i < this.messageList.length; i++) {
        if (
          flag === parseInt(this.messageList[i].flag, 10) &&
          this.messageList[i].show_popup === "1"
        ) {
          if (error === 1) {
            this._snackBar.open(this.messageList[i].text, "", {
              duration: 3000,
              panelClass: "error",
            });
            return false;
          } else if (error === 0) {
            this._snackBar.open(this.messageList[i].text, "", {
              duration: 3000,
              panelClass: "success",
            });
            return false;
          }
        }
      }
    }
  }

  customPopups(data: any, error: any,time=3000) {
    if (error === 1) {
      this._snackBar.open(data, "", { duration: time, panelClass: "error" });
    } else if (error === 0) {
      this._snackBar.open(data, "", { duration: time, panelClass: "success" });
    } else if (error === 2) {
      this._snackBar.open(data, "", { duration: time, panelClass: "warning" });
    } else if (error === 3) {
      this._snackBar.open(data.message, data.action, {
        duration: 3000,
        panelClass: "success",
      });
    }
  }

  customARPopups(data: any, error: any) {
    if (error === 1) {
      this._snackBar.open(data, "", { duration: 7000, panelClass: "error" });
    }
  }

  loginRedirect() {
    const currentUrl = this.router.url?.startsWith('/app/')
      ? this.router.url
      : (window.location.pathname + window.location.search);
    localStorage.removeItem("token");
    this.store.reset();
    // this.intercom.shutdown();
    Intercom('shutdown');
    this.auth.redirectToLogin(currentUrl);
  }

  clearPFData() {
    localStorage.removeItem("pfPatientFinance");
    localStorage.removeItem("financeDataSave");
    localStorage.removeItem("patientProfileSummary");
    localStorage.removeItem("financeScope");
    localStorage.removeItem("pfPatientEmail");
    localStorage.removeItem("selectedMonth");
    localStorage.removeItem("customMonth");
  }

  /** Verified industry list; fetched once and kept in the central store. */
  getIndustryList(): Observable<any[]> {
    return this.store.load("industries", () =>
      this.api({ is_verified: 1 }, "get_industry_list", false).pipe(
        map((data: any) => (data && data.is_error == 0 ? data.industries : null))
      )
    );
  }

  api(_data: any, url: any, flag: any, method?: string): Observable<any> {
    if (
      _data &&
      ((_data.note && _data.note.length && _data.note.length > 10000) ||
        (_data.notes && _data.notes.length && _data.notes.length > 10000))
    ) {
      this.customPopups("Note cannot exceed more than 10000 characters", 2);
      return of(false);
    }
    let api_url = localStorage.getItem("baseUrl");
    if (!api_url || api_url == "undefined" || api_url == undefined) {
      localStorage.removeItem("baseUrl");
      api_url = environment.baseUrl;
    }
    // if(url == 'get_zipcode'){
      // api_url = 'https://api.denefits.com/business3/';
    // }
    let output;
    let hitting_url = api_url + url;
    if (url.indexOf("http://") !== -1 || url.indexOf("https://") !== -1) {
      hitting_url = url;
    }
    if (method === "put") {
      output = this.http.put<any>(hitting_url, _data, {
        headers: this.headers,
      });
    } else if (method === "object") {
      output = this.http.post<any>(hitting_url, _data, {
        headers: this.headersObject,
      });
    } else {
      output = this.http.post<any>(hitting_url, _data, {
        headers: this.headers,
      });
    }

    return output.pipe(
      timeout(60000*60),
      retry(3),
      map((data: any) => {
        if (data.flag === 87) {
          this.loginRedirect();
          this.customPopups(data.err, 1);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }
        if (data.flag === 377) {
          this.loginRedirect();
          return false;
        }
        if (data.flag === 4 || data.flag === 309) {
          this.loginRedirect();
          if (data && (data.override_text || data.err)) {
            this.customPopups(data.override_text || data.err, 1);
          }
          return false;
        }

        if(data.flag == 503 && data.tracking_id == 'under_maintenance'){
          this.maintenanceContent = data;
          // this.loginRedirect();
          this.router.navigate(['maintenance']);
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
          return;
        }

        if (data && flag && !_data.is_skip_popup) {
          if (data.err) {
            if (data.override_text) {
              this.customPopups(data.override_text, 1);
            } else {
              this.customPopups(data.err, 1);
            }
          } else {
            this.flagPopUps(data.flag, data.is_error);
          }
        }
        return data;
      }),
      catchError((error: any) => {
        if (error instanceof TimeoutError) {
          if (!this.timeoutError) {
            this.timeoutError = true;
            this.customPopups("Request Timeout", 1);
          }
          return throwError({ error: "Timeout Exception" });
        }
        if (error.status === 0) {
          if (!this.timeoutError) {
            this.customPopups("Unable to fetch data from server", 1);
          }
        }
        if (error.status === 404) {
          if (!this.timeoutError) {
            this.customPopups("Invalid Request - URL not found", 1);
          }
        }
        return throwError(error);
      })
    );
  }

  uploadApi(_data: any, url: any, flag: any, method?: string): Observable<any> {
    let api_url = localStorage.getItem("baseUrl");
    if (!api_url || api_url == "undefined" || api_url == undefined) {
      localStorage.removeItem("baseUrl");
      api_url = environment.baseUrl;
    }
    return this.http.post<any>(`${api_url}${url}`, _data).pipe(
      timeout(6000000),
      map((data: any) => {
        if (data.flag === 377) {
          this.loginRedirect();
          return false;
        }
        if (data.flag === 4 || data.flag === 309) {
          this.loginRedirect();
          if (data && (data.override_text || data.err)) {
            this.customPopups(data.override_text || data.err, 1);
          }
          return false;
        }
        if (data && flag) {
          if (data.err) {
            if (data.override_text) {
              this.customPopups(data.override_text, 1);
            } else {
              this.customPopups(data.err, 1);
            }
          } else {
            this.flagPopUps(data.flag, data.is_error);
          }
        }
        return data;
      }),
      catchError((error: any) => {
        if (error instanceof TimeoutError) {
          if (!this.timeoutError) {
            this.timeoutError = true;
            this.customPopups("Request Timeout", 1);
          }
          return throwError({ error: "Timeout Exception" });
        }
        if (error.status === 0) {
          if (!this.timeoutError) {
            this.customPopups("Unable to fetch data from server", 1);
          }
        }
        return throwError(error);
      })
    );
  }

  uploadFileProgressApi(
    _data: any,
    url: any,
    flag: any,
    method?: string
  ): Observable<any> {
    let api_url = localStorage.getItem("baseUrl");
    if (!api_url || api_url == "undefined" || api_url == undefined) {
      localStorage.removeItem("baseUrl");
      api_url = environment.baseUrl;
    }
    return this.http
      .post<any>(`${api_url}${url}`, _data, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        timeout(60000*60),
        map((data: any) => {
          if (data.type === HttpEventType.UploadProgress) {
            const progress = Math.round((100 * data.loaded) / data.total);
            console.log(`File is ${progress}% uploaded.`);
            return { upload_progress: progress };
          } else if (data.type === HttpEventType.Response) {
            console.log(`File was completely uploaded!`);
          }
          if (data.type == 4) {
            data = data.body;
            if (data.flag === 377) {
              this.loginRedirect();
              return false;
            }
            if (data.flag === 4 || data.flag === 309) {
              this.loginRedirect();
              if (data && (data.override_text || data.err)) {
                this.customPopups(data.override_text || data.err, 1);
              }
              return false;
            }
            if (data && flag) {
              if (data.err) {
                if (data.override_text) {
                  this.customPopups(data.override_text, 1);
                } else {
                  this.customPopups(data.err, 1);
                }
              } else {
                this.flagPopUps(data.flag, data.is_error);
              }
            }

            console.log(data);

            return data;
          }
          return {};
        }),
        catchError((error: any) => {
          if (error instanceof TimeoutError) {
            if (!this.timeoutError) {
              this.timeoutError = true;
              this.customPopups("Request Timeout", 1);
            }
            return throwError({ error: "Timeout Exception" });
          }
          if (error.status === 0) {
            if (!this.timeoutError) {
              this.customPopups("Unable to fetch data from server", 1);
            }
          }
          return throwError(error);
        })
      );
  }

  guid() {
    const a = new Date();
    const nav = window.navigator;
    const screen = window.screen;
    let guid = nav.mimeTypes.length.toString();
    guid += nav.userAgent.replace(/\D+/g, "");
    guid += nav.plugins.length;
    guid += screen.height || "";
    guid += screen.width || "";
    guid += screen.pixelDepth || "";
    guid += a.getTime();
    return guid;
  }

  device_id(val: any) {
    const guidLog = this.guid();
    localStorage.setItem("user", guidLog);
  }

  device_info() {
    var window = window;
    var document = document;
    // Opera 8.0+
    var isOpera =
      navigator.userAgent.indexOf(" OPR/") >= 0 ||
      navigator.userAgent.indexOf("Opera") >= 0;
    // Firefox 1.0+
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    // Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // Edge 20+
    var isEdge = navigator.userAgent.indexOf("Edge") > -1;
    // Internet Explorer 6-11
    var isIE =
      typeof document !== "undefined" && !!document.documentMode && !isEdge;
    // Chrome 1 - 71
    var isChrome = !isOpera && !isEdge && !isSafari;
    // Blink engine detection
    var isBlink = (isChrome || isOpera) && window && !!window.CSS;
    var browserInfo = {
      isFirefox: isFirefox,
      isChrome: isChrome,
      isSafari: isSafari,
      isOpera: isOpera,
      isIE: isIE,
      isEdge: isEdge,
      isBlink: isBlink,
    };
    var platform =
      navigator && navigator.platform ? navigator.platform : "unknown";
    var userAgent =
      navigator && navigator.userAgent ? navigator.userAgent : "unknown";
    return {
      browser: browserInfo,
      platform: platform,
      userAgent: userAgent,
    };
  }

  init() {

    this.scriptLoader.loadScript(`https://www.google.com/recaptcha/api.js?render=${environment.google_captcha_sitekey}`)
    .then(() => {
      console.log('Script loaded!');
      // You can now access the library if it attaches globally
    })
    .catch(err => {
      console.error(err);
    });

    if (!localStorage.getItem("timezone")) {
      localStorage.setItem("timezoneName", "PST");
      localStorage.setItem("timezone", "-0700");
    }
    const aT = window.location.href.split("token=");
    if (aT[1]) {
      localStorage.setItem("token", aT[1]);
    }
    if (typeof localStorage === "object") {
      try {
        localStorage.setItem("localStorage", "1");
        localStorage.removeItem("localStorage");
      } catch (e) {
        const alertMesg =
          "Your web browser does not support storing settings locally" +
          ', most common cause of this is using "Private Browsing Mode".' +
          " Some settings may not work properly for you. Please switch to normal browsing mode.";
        alert(alertMesg);
      }
    }

    this.device_id(0);
    if (localStorage.getItem("user")) {
      const envId = localStorage.getItem("envId");
      if (envId && !environment.production && !environment.demo) {
        const envs = [
          { id: 1, name: "t1", url: "https://api.denefits.com/business/" },
          { id: 2, name: "t2", url: "https://api.denefits.com/business2/" },
          { id: 3, name: "t3", url: "https://api.denefits.com/business3/" },
          { id: 4, name: "t4", url: "https://api.denefits.com/business4/" },
          { id: 5, name: "t5", url: "https://api.denefits.com/business5/" },
          { id: 5, name: "d1", url: "https://demoapi.denefits.com/business/" },
        ];

        const currentEnv = envs.find((env: any) => env.id == envId);
        if (currentEnv) {
          environment.baseUrl = currentEnv.url;
          environment.env = currentEnv.name;
          localStorage.setItem("environment", currentEnv.name);
          localStorage.setItem("env", currentEnv.name);
          localStorage.setItem("baseUrl", currentEnv.url);
        }
      }

      let data = {
        device_type: environment.device_type,
        app_type: environment.app_type,
        app_version: environment.app_version,
        device_token: environment.device_token,
        device_id: localStorage.getItem("user"),
        device_info: this.device_info(),
        access_token: localStorage.getItem("token"),
        env: environment.env,
        times: 1
      };
      if (!environment.production) {
        data["environment"] = localStorage.getItem("environment") || environment.env || "t1";
      }

      let api_url = localStorage.getItem("baseUrl");
      if (!api_url || api_url == "undefined" || api_url == undefined) {
        localStorage.removeItem("baseUrl");
        api_url = environment.baseUrl;
      }
      if (data.access_token && data.access_token != null) {
        this.auth.accessTokenLogin();
      }

      this.http
        .post<any>(api_url + API.GET_SETTINGS, data, {
          headers: this.headersObject,
        })
        .subscribe((response) => {
          if (this.storageVal) {
            const clientVer = localStorage.getItem("client_version")
              ? localStorage.getItem("client_version")
              : "1";
            if (Number(clientVer) < Number(this.storageVal.client_version)) {
              if (
                this.storageVal.delete_localstorage &&
                JSON.parse(this.storageVal.delete_localstorage)
              ) {
                console.log("in get settings api");
                localStorage.setItem(
                  "client_version",
                  this.storageVal.client_version
                );
                // window.location.reload();
              } else if (
                this.storageVal.hard_reload &&
                JSON.parse(this.storageVal.hard_reload)
              ) {
                alert(
                  "Please hard reload (Ctrl + Shift + R) to see the updated features. Thank you"
                );
                localStorage.setItem(
                  "client_version",
                  this.storageVal.client_version
                );
              }
            }
          }
          if(response && response.support_data) {
            this.defaultcontact = response.support_data;
          }
          if (response.menu) {
            this.available_menu.next(response.menu);
            if(location.pathname == '/maintenance') {
              // this.loginRedirect();
              this.router.navigate(['app/finance-customer']);
              // setTimeout(() => {
              //   window.location.reload();
              // }, 1000);
            }
          } else {
            this.getsettings_count++;
            if (this.getsettings_count == 1) {
              this.init();
            } else if (response.flag == 503 && response.tracking_id == 'under_maintenance' ) {
              localStorage.removeItem('baseUrl');
              this.maintenanceContent = response;
              this.router.navigate(['maintenance']);
              this.reloadWbsite(response.maintenance_time);
              return;
            } else {
              this.loginRedirect();
            }
          }

          if(response.languages){
            localStorage.setItem("languages", JSON.stringify(response.languages));
          }
          if(response.invalid_ssn){
            localStorage.setItem("invalid_ssn", JSON.stringify(response.invalid_ssn));
          }

          this.getsettings_response = response;
          if (
            this.getsettings_response.flag === 70 ||
            this.getsettings_response.update_message
          ) {
            location.reload();
            return false;
          }
          if (environment.production) {
            let prev_base = localStorage.getItem("baseUrl");
            if (prev_base == "undefined" || prev_base == undefined) {
              localStorage.removeItem("baseUrl");
            }
            environment.baseUrl = "https://apilivev2.denefits.com/business/";
          } else if (response.server_url) {
            // Only trust server_url when the response actually has it; error/maintenance
            // responses don't, which used to store "undefined/" as the base url.
            environment.baseUrl = response.server_url + "/";
            // environment.baseUrl = "https://api.denefits.com/business3/";
          }

          if (environment.baseUrl && !environment.baseUrl.startsWith("undefined")) {
            localStorage.setItem("baseUrl", environment.baseUrl);
          }

          if (
            this.getsettings_response &&
            this.getsettings_response.stripe_pk
          ) {
            this.stripeKeySubject.next(this.getsettings_response.stripe_pk);
            Stripe.setPublishableKey(this.getsettings_response.stripe_pk);
            this.stripe = Stripe(this.getsettings_response.stripe_pk);
            this.stripe_element = this.stripe
              .elements()
              .create("card", { hidePostalCode: false, style: this.style });
          }
          // Stripe.setPublishableKey(this.getsettings_response.stripe_pk);
          this.messageList = this.getsettings_response.popups;
          this.user_review_list = this.getsettings_response.user_review_list; // Message List for how did you hear about us?
          this.salutation = this.getsettings_response.salutation;
          this.store.set("salutations", this.getsettings_response.salutation);
          if (data && data.access_token) {
            this.store.set("arProposals", this.getsettings_response.total_arv2_proposals);
          }
          if(response.preapproval_leads_object){
            this.store.set("preapprovalLeads", response.preapproval_leads_object);
          }
          this.store.set("timezones", response.timezones);
          this.persona_template_id = response.persona_template_id;

          var urlObject = new URL(window.location.href);

          // Get the search parameters from the URL
          var searchParams = urlObject.searchParams;

          // Get individual parameters by name
          var param1 = searchParams.get("lang");
          let allOptions = document.querySelectorAll(`[data-gt-lang]`);
          function userRevice() {
            setTimeout(() => {
              const urlObject = new URL(window.location.href);
              console.log(urlObject.search);
              if(urlObject.search) {
                urlObject.search = "";

                var [baseUrl, queryString] = window.location.href.split('?');

                // Split the query string into individual parameters
                var params = queryString.split('&');

                // Filter out the "lang" parameter
                var filteredParams = params.filter(function(param) {
                  return !param.startsWith('lang=');
                });

                // Reconstruct the URL with the "lang" parameter removed
                var newUrl = baseUrl + '?' + filteredParams.join('&');


                window.location.href = newUrl;
              }
              else {
                if (!["/app/finance", "/app/help/support", "/app/help/calculator", "/app/accounts-receivable/send-invoice", "/app/process-payment/payment", "/app/finance-customer"].includes(window.location.pathname)) {
                  setTimeout(() => {
                    window.location.reload()
                  }, 1000);
                }
              }
            }, 200);
          }
          Array.from(allOptions).map((item) => {
            item.removeEventListener("click", userRevice);
            item.addEventListener("click", userRevice);
          });

          if (
            param1 &&
            param1 != this.gt_get_cookie("googtrans").split("/").pop()
          ) {
            document["cookie"] = String(`googtrans=${"/en/" + param1}`);
            document.querySelector(`.gt-current-lang`)["click"]();
            let options1 = document.querySelector(`[data-gt-lang="${param1}"]`);
            let options = document.querySelector(`.gt_options`);
            options.classList.remove("gt-open");
            options1["click"]();
          }
        });
    } else {
      this.device_id(1);
    }
    this.Show_grid_full_view();
    this.display_challenge_popup();
  }

  dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  getPreviousUrl() {
    return this.previousUrl;
  }

  downloadApi(data: any, url: any, view: any) {
    let config = {
      headers: this.headers,
      responseType: "blob" as "json",
      observe: "response" as "body",
    };
    let api_url = localStorage.getItem("baseUrl");
    if (!api_url || api_url == "undefined" || api_url == undefined) {
      localStorage.removeItem("baseUrl");
      api_url = environment.baseUrl;
    }
    return this.http.post<any>(`${api_url}${url}`, data, config).pipe(
      timeout(60000),
      map((data: any) => {
        function extractFirstText(str) {
          const matches = str.match(/"(.*?)"/);
          return matches ? matches[1] : str;
        }
        let headers = data.headers.get("Content-Disposition");
        let fileName = extractFirstText(headers);
        data = data.body;
        var blob = new Blob([data], { type: "application/pdf" });
        var urlwindow = window.URL.createObjectURL(blob);
        if (view == 0) {
          var anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = urlwindow;
          anchor.click();
        } else if (view == 1) {
          var pwa = window.open(urlwindow);
          if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
            alert(
              "Please disable your browser's pop-up blocker and try again."
            );
          }
        } else if (view == 2) {
          var w = window.open(urlwindow, "", "width=800,height=800");
          if (!w || w.closed || typeof w.closed == "undefined") {
            alert(
              "Please disable your browser's pop-up blocker and try again."
            );
          }
          if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
            w.location.reload();
          }
          w.focus();
          w.print();
        }
      }),
      catchError((error: any) => {
        console.log(error);
        if (error instanceof TimeoutError) {
          if (!this.timeoutError) {
            this.timeoutError = true;
            this.customPopups("Request Timeout", 1);
          }
          return throwError({ error: "Timeout Exception" });
        }
        if (error.status == 0) {
          if (!this.timeoutError) {
            this.customPopups("Unable to fetch data from server", 1);
          }
        }
        return throwError(error);
      })
    );
  }

  downloadApiXlsX(data: any, url: any, view: any) {
    let config = {
      headers: this.headers,
      responseType: "blob" as "json",
      observe: "response" as "body",
    };
    let api_url = localStorage.getItem("baseUrl");
    if (!api_url || api_url == "undefined" || api_url == undefined) {
      localStorage.removeItem("baseUrl");
      api_url = environment.baseUrl;
    }
    return this.http.post<any>(`${api_url}${url}`, data, config).pipe(
      timeout(60000),
      map((data: any) => {
        let headers = data.headers.get("Content-Disposition");
        let fileName = "report.xlsx";
        data = data.body;
        var blob = new Blob([data], { type: "application/csv" });
        var urlwindow = window.URL.createObjectURL(blob);
        if (view == 0) {
          var anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = urlwindow;
          anchor.click();
        } else if (view == 1) {
          var pwa = window.open(urlwindow);
          if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
            alert(
              "Please disable your browser's pop-up blocker and try again."
            );
          }
        } else if (view == 2) {
          var w = window.open(urlwindow, "", "width=800,height=800");
          if (!w || w.closed || typeof w.closed == "undefined") {
            alert(
              "Please disable your browser's pop-up blocker and try again."
            );
          }
          if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
            w.location.reload();
          }
          w.focus();
          w.print();
        }
      }),
      catchError((error: any) => {
        console.log(error);
        if (error instanceof TimeoutError) {
          if (!this.timeoutError) {
            this.timeoutError = true;
            this.customPopups("Request Timeout", 1);
          }
          return throwError({ error: "Timeout Exception" });
        }
        if (error.status == 0) {
          if (!this.timeoutError) {
            this.customPopups("Unable to fetch data from server", 1);
          }
        }
        return throwError(error);
      })
    );
  }

  getCurrentTimezone() {
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + (time % 60)).slice(-2);
    let user_timezone = "";
    if (time > 0) {
      user_timezone = "-" + hours + minutes;
    } else {
      user_timezone = "+" + hours + minutes;
    }
    return user_timezone;
  }

  getCalculatedTransactionFee(contract, comparable_value) {
    comparable_value = parseFloat(comparable_value);
    contract.recurring_extra_amount = parseFloat(
      contract.recurring_extra_amount
    );
    contract.recurring_extra_percent = parseFloat(
      contract.recurring_extra_percent
    );
    contract.threshold_amount = parseFloat(contract.threshold_amount);
    contract.threshold_recurring_extra_amount = parseFloat(
      contract.threshold_recurring_extra_amount
    );
    contract.threshold_recurring_extra_percent = parseFloat(
      contract.threshold_recurring_extra_percent
    );
    let transaction_fee = 0;
    if (comparable_value === 0) {
      return 0;
    } else if (
      comparable_value < contract.threshold_amount ||
      (contract.threshold_amount === undefined &&
        contract.recurring_extra_amount !== undefined)
    ) {
      if (contract.recurring_extra_percent) {
        transaction_fee +=
          (comparable_value * contract.recurring_extra_percent) / 100;
      }
      if (contract.recurring_extra_amount) {
        transaction_fee += contract.recurring_extra_amount;
      }
    } else {
      if (contract.threshold_recurring_extra_percent) {
        transaction_fee +=
          (comparable_value * contract.threshold_recurring_extra_percent) / 100;
      }
      if (contract.threshold_recurring_extra_amount) {
        transaction_fee += contract.threshold_recurring_extra_amount;
      }
    }
    return transaction_fee;
  }

  copyText(val) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    try {
      var successful = document.execCommand("copy");
      if (!successful) throw successful;
      this.customPopups("Copied Successfully!", 0);
    } catch (err) {
      window.prompt("Copy to clipboard: Ctrl+C, Enter", val);
    }
    document.body.removeChild(selBox);
  }

  covertDateTimesAgo(sent_date) {
    let date = new Date(sent_date);
    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    if (seconds < 5) {
      return "just now";
    } else if (seconds < 60) {
      return seconds + " seconds ago";
    } else if (seconds < 3600) {
      var minutes = Math.floor(seconds / 60);
      if (minutes > 1) return minutes + " minutes ago";
      else return "1 minute ago";
    } else if (seconds < 86400) {
      var hours = Math.floor(seconds / 3600);
      if (hours > 1) return hours + " hours ago";
      else return "1 hour ago";
    }
    //2 days and no more
    else if (seconds < 172800) {
      var days = Math.floor(seconds / 86400);
      if (days > 1) return days + " days ago";
      else return "1 day ago";
    } else {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? 0 + minutes : minutes;
      return (
        months[date.getMonth()] +
        " " +
        date.getDate().toString() +
        " at " +
        ("0" + hours).slice(-2) +
        ":" +
        ("0" + minutes).slice(-2) +
        ampm
      );
    }
  }

  socialLogin(data) {
    let data1 = {
      device_type: environment.device_type,
      app_type: environment.app_type,
      app_version: environment.app_version,
      device_token: environment.device_token,
      device_id: localStorage.getItem("user"),
      access_token: data.token,
      environment: environment.env,
    };
    let data_1 = { ...data1, ...data };
    this.http
      .post<any>(environment.baseUrl + "social_signup", data_1, {
        headers: this.headers,
      })
      .subscribe((data) => {
        if (data && data.is_error == 0) {
          this.auth.setLoginData(data);
          this.available_menu.next(data.menu);
          this.auth.accessTokenLogin();
          return;
        }
      });
  }

  resetActiveFinanceDoctor(): void {
    this.activeFinanceDoctorId = null;
  }

  setFinanceThemeFromLocations(locations: any[], selectedDoctorId?: number | string): void {
    if (!locations?.length) {
      this.newfinanceUi = false;
      return;
    }

    if (selectedDoctorId && selectedDoctorId !== 'All') {
      const location = locations.find(item => item.doctor_id == selectedDoctorId);
      this.newfinanceUi = Number(location?.doctor_financing_theme ?? 0) === 1;
      return;
    }

    this.newfinanceUi = locations.every(loc => Number(loc.doctor_financing_theme ?? 0) === 1);
  }

  getShowPpSubscriptionFromLocations(locations: any[], selectedDoctorId?: number | string): boolean {
    if (!locations?.length) {
      return false;
    }

    if (selectedDoctorId && selectedDoctorId !== 'All') {
      const location = locations.find(item => item.doctor_id == selectedDoctorId);
      return Number(location?.show_pp_subscription ?? 0) === 1;
    }

    return locations.every(loc => Number(loc.show_pp_subscription ?? 0) === 1);
  }

  /* Host serving Denefits' shared/placeholder imagery — never a business logo */
  private readonly placeholderLogoHost = 'common.denefits.com';
  pickBusinessLogo(...candidates: any[]): string {
    return candidates
      .map(candidate => String(candidate || '').trim())
      .find(url => url && !url.toLowerCase().includes(this.placeholderLogoHost)) || '';
  }

  /**
   * Subscription flow the business is on: 0 -> legacy subscription screens,
   * 1 -> Subscription v2.
   *
   * This is a per-business (per-location) flag, not a per-user one. A business
   * owner's profile row carries it, but an agent (role_id 5) signs in with an
   * agent row that does not — reading `userProfileData` alone made every agent
   * fall back to 0 and land on the legacy subscription card. So resolve it the
   * way `show_pp_subscription` / `doctor_financing_theme` already are:
   * location-scoped settings first, the profile row only as a last resort.
   */
  getSubscriptionFlowType(selectedDoctorId?: number | string): number {
    const flag = this.resolveSubscriptionFlowFlag(selectedDoctorId);
    return flag == null ? 0 : Number(flag);
  }

  isSubscriptionV2Flow(selectedDoctorId?: number | string): boolean {
    return this.getSubscriptionFlowType(selectedDoctorId) === 1;
  }

  /**
   * First place the flag actually turns up, in priority order. Every source is
   * optional — whichever one the backend populates for this role wins, and an
   * absent flag reads as legacy rather than as 0-from-a-missing-object.
   */
  private resolveSubscriptionFlowFlag(selectedDoctorId?: number | string): any {
    const currentLoc = this.readStoredJson('currentLoc');
    const docId = selectedDoctorId ?? this.activeFinanceDoctorId ?? currentLoc?.id;
    const isSingleLocation = !!docId && docId !== 'All';

    const locations = this.readStoredJson('locations');
    const locationFlag = this.getSubscriptionFlowFromLocations(locations, docId);
    const doctorSettings = this.readStoredJson('doctorSettings');
    const profile = this.readStoredJson('userProfileData');
    const profileFlag = profile && profile[0] && profile[0].subscription_flow_type;
    const settingsFlags = [
      doctorSettings?.subscription_flow_type,
      this.readJsonValue(doctorSettings?.pp_subscription_settings)?.subscription_flow_type,
    ];

    if (!isSingleLocation) {
      // "All locations" — the finance response belongs to whichever location was
      // last opened, so only the location list can speak for the whole account.
      return this.firstDefined([locationFlag, ...settingsFlags, profileFlag]);
    }

    const finance = this.financeData?.data ? this.financeData : this.readStoredJson('getFinanceValues');
    const financeData = finance?.data;
    const validateData = Array.isArray(financeData?.validateInputData) ? financeData.validateInputData[0] : null;

    return this.firstDefined([
      financeData?.subscription_flow_type,
      this.readJsonValue(financeData?.payment_process_subscription_settings)?.subscription_flow_type,
      validateData?.subscription_flow_type,
      ...settingsFlags,
      locationFlag,
      profileFlag,
    ]);
  }

  private getSubscriptionFlowFromLocations(locations: any[], selectedDoctorId?: number | string): any {
    if (!locations?.length) {
      return undefined;
    }

    if (selectedDoctorId && selectedDoctorId !== 'All') {
      return locations.find(item => item.doctor_id == selectedDoctorId)?.subscription_flow_type;
    }

    const flags = locations.map(loc => loc.subscription_flow_type).filter(flag => flag !== undefined && flag !== null);
    if (!flags.length) {
      return undefined;
    }

    return flags.every(flag => Number(flag) === 1) ? 1 : 0;
  }

  private firstDefined(values: any[]): any {
    return values.find(value => value !== undefined && value !== null && value !== '');
  }

  /** `pp_subscription_settings` and friends ship as either an object or a JSON string. */
  private readJsonValue(value: any): any {
    if (!value) {
      return null;
    }
    if (typeof value !== 'string') {
      return value;
    }
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  private readStoredJson(key: string): any {
    try {
      return JSON.parse(localStorage.getItem(key) || 'null');
    } catch {
      return null;
    }
  }

  getFinanceValues(docId, type?, need_result?) {
    this.activeFinanceDoctorId = docId;
    const shouldUseFinanceLoader = !this.newfinanceUi;
    const data = {
      access_token: localStorage.getItem("token"),
      doctor_id: docId,
      from_cache: 0,
      contract_type:
        type === "tenPercent"
          ? 1
          : type === "inHouse"
          ? 3
          : type === "easyFinance"
          ? 4
          : type === "deferredInterst"
          ? 6
          : 2,
          hideLoader: true,
    };
    if (shouldUseFinanceLoader) {
      this.loaderService.show();
    }

    return this.api(data, `get_can_finance_status`, false).subscribe((response) => {
      if (response.is_error) {
        if (shouldUseFinanceLoader) {
          this.loaderService.hide();
        }
        this.financeData$.next(null);
        localStorage.removeItem('getFinanceValues');
        this.financeData = [];
        if (this.activeFinanceDoctorId == docId) {
          this.newfinanceUi = false;
        }
      } else {
        if (shouldUseFinanceLoader) {
          this.loaderService.hide();
        }
        if (this.activeFinanceDoctorId == docId) {
          this.newfinanceUi = this.isNewFinanceThemeEnabled(response);
        }
        localStorage.setItem("getFinanceValues", JSON.stringify(response));
        if(localStorage.getItem('roleId') == '1') {
          setDoctorSettings(response.data);
          this.auth.doctorDefaultVales$.next(response.data);
        }
        localStorage.setItem("doctorProfile", JSON.stringify(response.data));
        this.financeData = response;
        this.financeData$.next(response);
        if(need_result) {
          // setTimeout(()=>{
            need_result(response)
          // }, 100)
        }
      }
    }, () => {
      if (shouldUseFinanceLoader) {
        this.loaderService.hide();
      }
      this.financeData$.next(null);
      localStorage.removeItem('getFinanceValues');
      this.financeData = [];
      if (this.activeFinanceDoctorId == docId) {
        this.newfinanceUi = false;
      }
    });
  }

  private isNewFinanceThemeEnabled(financeResponse: any): boolean {
    const data = financeResponse?.data || financeResponse || {};
    const validateData = Array.isArray(data?.validateInputData) ? (data.validateInputData[0] || {}) : {};
    return Number(data?.doctor_financing_theme ?? validateData?.doctor_financing_theme ?? 0) === 1;
  }

  goBack() {
    this.location.back();
  }

  handleInputSpace(event) {
    if (event.target.selectionStart === 0 && event.code === "Space") {
      event.preventDefault();
    }
  }

  Show_grid_full_view() {
    if (!localStorage.getItem("show_full_view")) {
      localStorage.setItem("show_full_view", "false");
    }
    this.show_full_view = JSON.parse(localStorage.getItem("show_full_view"));
  }

  update_list_grid_view(value) {
    if (value) {
      localStorage.setItem("show_full_view", "true");
    } else {
      localStorage.setItem("show_full_view", "false");
    }
    this.show_full_view = value;
  }

  subscription_global_setting(f_id) {
    let doctorSettings = localStorage.getItem('doctorSettings') ? getDoctorSettings() : [];
    if (doctorSettings && doctorSettings.show_subscription && doctorSettings.show_subscription == 1) {
      this.subscription_data = localStorage.getItem("subscription_data")
        ? JSON.parse(localStorage.getItem("subscription_data"))
        : null;
      if (this.subscription_data) {
        for (const [key, value] of Object.entries(
          this.subscription_data.plan_feature
        )) {
          if (value["f_id"] == f_id) {
            if (value["is_allowed"] == 1) {
              return true;
            } else {
              return false;
            }
          }
        }
      } else {
        this.hit_subscription = false;
        if (this.hit_subscription) {
          this.auth.getUsersubscription();
        }
        setTimeout(() => {
          this.recall_subscription_global_setting(f_id);
        }, 2000);
      }
    } else {
      return true;
    }
  }

  recall_subscription_global_setting(f_id?) {
    this.subscription_global_setting(f_id);
  }

  gt_get_cookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


  removeLangParameter(url) {
    // Split the URL into the base URL and the query string
    var [baseUrl, queryString] = url.split('?');

    // Split the query string into individual parameters
    var params = queryString.split('&');

    // Filter out the "lang" parameter
    var filteredParams = params.filter(function(param) {
      return !param.startsWith('lang=');
    });

    // Reconstruct the URL with the "lang" parameter removed
    var newUrl = baseUrl + '?' + filteredParams.join('&');
    return newUrl;
  }

  time_in_format_utc_current(time) {
    if (time) {
      let now = new Date(`${this.datePipe.transform(new Date(new Date().setHours(0, 0, 0, 0)), 'MM/dd/yyyy')} ${time}`);
    now =  new Date(now.getTime() - now.getTimezoneOffset() * 60000)
     return this.datePipe.transform(now, 'hh:mm a', this.getCurrentTimezone())
    } else {
      return
    }
  }

  timeinformat(time) {
    if (time) {
      let ampm = " AM"
      let temptime = time.split(":").slice(0,2);
      if (temptime[0] > 12) {
        temptime[0] = Math.abs(temptime[0] - 12)
        ampm = " PM"
      }else if(temptime[0] == 12){
        ampm = " PM"
      }
      return temptime.join(':') + ampm
    } else {
      return
    }
  }

  reloadWbsite(time: any) {
    setTimeout(() => {
      this.router.navigate(['app/finance-customer']);
      window.location.reload();
    }, (time * 1000));
  }

  checkDOB(event) {
    if(event.target.value && event.target.value.length > 0 ) {
      this.warningText = '';
    }
  }

  openTrainingModal(): void {
    let roleId = this.auth.role_id
    if (roleId != 4)
      this.router.navigate(['/app/help/trainings/schedule'])
    else {
      let confirmDialogRef;
      confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
        width: '471px',
        panelClass: 'simpleDialog',
        data: {
          type: 802,
          // timezones: response.data
        }
      });


      confirmDialogRef.afterClosed().subscribe(result => {
        console.log(result)
      })
    }
  }

  openTrainingModalForpp(): void {
    let confirmDialogRef;
    confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '430px',
      panelClass: 'simpleDialog',
      data: {
        type: 901,
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      console.log(result)
    })
  }

  display_challenge_popup(){
    let temp_count=0;
    this._socket.socket.on('display_popup', (business_challenge) => {
      if(!business_challenge || !this.currentUrl.includes("/app") || temp_count>0) return
      temp_count++
      if (business_challenge.is_chlng_actv_this_mnth) {
        if (business_challenge.need_to_create_contract && !business_challenge.contract_this_month) {
          this.dialog.open(SimpleDialogComponent, {
            width: '520px',
            panelClass: 'simpleDialog',
            data: {
              type: 806,
              send_data: business_challenge
            },
            disableClose: false
          });
        } else if (business_challenge.need_to_create_contract && business_challenge.contract_this_month && (business_challenge.need_to_create_contract == business_challenge.contract_this_month)) {
          this.dialog.open(SimpleDialogComponent, {
            width: '520px',
            panelClass: 'simpleDialog',
            data: {
              type: 803,
              send_data: business_challenge
            },
            disableClose: false
          });
        }

      }else if( business_challenge.is_new_business_challenge && !business_challenge.is_new_business_challenge_achieved){
        const userProfileData = JSON.parse(localStorage.getItem('userProfileData') || '[]');
        const show100DollarChallange = userProfileData && userProfileData[0] && userProfileData[0].show_100_dollar_challenge || 0;
        if (show100DollarChallange == 1) {
          this.dialog.open(SimpleDialogComponent, {
            width: '520px',
            panelClass: 'simpleDialog',
            data: {
              type: 805,
              send_data: business_challenge
            },
            disableClose: false
          });
        }
      }
      setTimeout(() => {
        temp_count=0;
      }, 60000);
    });
  }


  public getTraningData:any=[]
  getTrainingsList() {
    const data = {
      access_token: localStorage.getItem('token'),
      page: 0,
      hideLoader:true,
      time_type: "upcoming",
      remove_limit: 0,
      status: ""
    }
    this.api(data, `get_doctor_training_schdules`, true)
      .subscribe(response => {
        if (response.is_error) {
        } else {
          this.getTraningData = response.data.filter((item: any) =>
             ((item.training_status_name === "Scheduled" || item.training_status_name === "Rescheduled")&&item.type_name == "Denefits Training")
          );
          if(this.getTraningData.length<=0){
            this.getTraningData=[]
          }
        }
      });
  }

  setExpandedState(isExpanded: boolean): void {
    this.expandedState.next(isExpanded);
  }

  requestSidebarToggle(isExpanded: boolean): void {
    this.sidebarToggleRequest.next(isExpanded);
  }

  requestSidebarVisibility(isVisible: boolean): void {
    this.sidebarVisibilityRequest.next(isVisible);
  }

  encrypt(value: number): string {
    const stringValue = value.toString();
    return CryptoJS.AES.encrypt(stringValue, this.secretKey).toString();
  }

  decrypt(encryptedValue: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  encryptInMD5(value: number): string {
    const stringValue = value.toString();
    return CryptoJS.MD5(stringValue).toString();
  }
}
